export const isoLookups = {
  Afghanistan: { iso3: "AFG", iso2: "af" },
  Albania: { iso3: "ALB", iso2: "al" },
  Algeria: { iso3: "DZA", iso2: "dz" },
  Andorra: { iso3: "AND", iso2: "ad" },
  Angola: { iso3: "AGO", iso2: "ao" },
  Argentina: { iso3: "ARG", iso2: "ar" },
  Armenia: { iso3: "ARM", iso2: "am" },
  Aruba: { iso3: "ABW", iso2: "aw" },
  Australia: { iso3: "AUS", iso2: "au" },
  Austria: { iso3: "AUT", iso2: "at" },
  Azerbaijan: { iso3: "AZE", iso2: "az" },
  Bahamas: { iso3: "BHS", iso2: "bs" },
  Bahrain: { iso3: "BHR", iso2: "bh" },
  Bangladesh: { iso3: "BGD", iso2: "bd" },
  Barbados: { iso3: "BRB", iso2: "bb" },
  Belarus: { iso3: "BLR", iso2: "by" },
  Belgium: { iso3: "BEL", iso2: "be" },
  Belize: { iso3: "BLZ", iso2: "bz" },
  Benin: { iso3: "BEN", iso2: "bj" },
  Bermuda: { iso3: "BMU", iso2: "bm" },
  Bhutan: { iso3: "BTN", iso2: "bt" },
  Bolivia: { iso3: "BOL", iso2: "bo" },
  "Bonaire, Sint Eustatius and Saba": { iso3: "BES", iso2: "bq" },
  "Bosnia and Herzegovina": { iso3: "BIH", iso2: "ba" },
  Botswana: { iso3: "BWA", iso2: "bw" },
  Brazil: { iso3: "BRA", iso2: "br" },
  "British Virgin Islands": { iso3: "VGB", iso2: "vg" },
  Brunei: { iso3: "BRN", iso2: "bn" },
  Bulgaria: { iso3: "BGR", iso2: "bg" },
  "Burkina Faso": { iso3: "BFA", iso2: "bf" },
  Burundi: { iso3: "BDI", iso2: "bi" },
  Cambodia: { iso3: "KHM", iso2: "kh" },
  Cameroon: { iso3: "CMR", iso2: "cm" },
  Canada: { iso3: "CAN", iso2: "ca" },
  "Cape Verde": { iso3: "CPV", iso2: "cv" },
  "Cayman Islands": { iso3: "CYM", iso2: "ky" },
  "Central African Republic": { iso3: "CAF", iso2: "cf" },
  Chad: { iso3: "TCD", iso2: "td" },
  Chile: { iso3: "CHL", iso2: "cl" },
  China: { iso3: "CHN", iso2: "cn" },
  Colombia: { iso3: "COL", iso2: "co" },
  Comoros: { iso3: "COM", iso2: "km" },
  "Congo DRC": { iso3: "COD", iso2: "cd" },
  "Congo, Rep.": { iso3: "COG", iso2: "cg" },
  "Costa Rica": { iso3: "CRI", iso2: "cr" },
  "Cote d'Ivoire": { iso3: "CIV", iso2: "ci" },
  Croatia: { iso3: "HRV", iso2: "hr" },
  Cuba: { iso3: "CUB", iso2: "cu" },
  Curaçao: { iso3: "CUW", iso2: "cw" },
  Cyprus: { iso3: "CYP", iso2: "cy" },
  Czechia: { iso3: "CZE", iso2: "cz" },
  Denmark: { iso3: "DNK", iso2: "dk" },
  Djibouti: { iso3: "DJI", iso2: "dj" },
  Dominica: { iso3: "DMA", iso2: "dm" },
  "Dominican Republic": { iso3: "DOM", iso2: "do" },
  Ecuador: { iso3: "ECU", iso2: "ec" },
  Egypt: { iso3: "EGY", iso2: "eg" },
  "El Salvador": { iso3: "SLV", iso2: "sv" },
  "Equatorial Guinea": { iso3: "GNQ", iso2: "gq" },
  Eritrea: { iso3: "ERI", iso2: "er" },
  Estonia: { iso3: "EST", iso2: "ee" },
  Eswatini: { iso3: "SWZ", iso2: "sz" },
  Ethiopia: { iso3: "ETH", iso2: "et" },
  "Falkland Islands": { iso3: "FLK", iso2: "fk" },
  "Faroe Islands": { iso3: "FRO", iso2: "fo" },
  Fiji: { iso3: "FJI", iso2: "fj" },
  Finland: { iso3: "FIN", iso2: "fi" },
  France: { iso3: "FRA", iso2: "fr" },
  "French Polynesia": { iso3: "PYF", iso2: "pf" },
  Gabon: { iso3: "GAB", iso2: "ga" },
  Gambia: { iso3: "GMB", iso2: "gm" },
  Georgia: { iso3: "GEO", iso2: "ge" },
  Germany: { iso3: "DEU", iso2: "de" },
  Ghana: { iso3: "GHA", iso2: "gh" },
  Gibraltar: { iso3: "GIB", iso2: "gi" },
  Greece: { iso3: "GRC", iso2: "gr" },
  Greenland: { iso3: "GRL", iso2: "gl" },
  Grenada: { iso3: "GRD", iso2: "gd" },
  Guatemala: { iso3: "GTM", iso2: "gt" },
  Guernsey: { iso3: "GGY", iso2: "gg" },
  Guinea: { iso3: "GIN", iso2: "gn" },
  "Guinea-Bissau": { iso3: "GNB", iso2: "gw" },
  Guyana: { iso3: "GUY", iso2: "gy" },
  Haiti: { iso3: "HTI", iso2: "ht" },
  Honduras: { iso3: "HND", iso2: "hn" },
  "Hong Kong": { iso3: "HKG", iso2: "hk" },
  Hungary: { iso3: "HUN", iso2: "hu" },
  Iceland: { iso3: "ISL", iso2: "is" },
  India: { iso3: "IND", iso2: "in" },
  Indonesia: { iso3: "IDN", iso2: "id" },
  Iran: { iso3: "IRN", iso2: "ir" },
  Iraq: { iso3: "IRQ", iso2: "iq" },
  Ireland: { iso3: "IRL", iso2: "ie" },
  "Isle of Man": { iso3: "IMN", iso2: "im" },
  Israel: { iso3: "ISR", iso2: "il" },
  Italy: { iso3: "ITA", iso2: "it" },
  Jamaica: { iso3: "JAM", iso2: "jm" },
  Japan: { iso3: "JPN", iso2: "jp" },
  Jersey: { iso3: "JEY", iso2: "je" },
  Jordan: { iso3: "JOR", iso2: "jo" },
  Kazakhstan: { iso3: "KAZ", iso2: "kz" },
  Kenya: { iso3: "KEN", iso2: "ke" },
  Kiribati: { iso3: "KIR", iso2: "ki" },
  Kuwait: { iso3: "KWT", iso2: "kw" },
  "Kyrgyz Republic": { iso3: "KGZ", iso2: "kg" },
  Laos: { iso3: "LAO", iso2: "la" },
  Latvia: { iso3: "LVA", iso2: "lv" },
  Lebanon: { iso3: "LBN", iso2: "lb" },
  Lesotho: { iso3: "LSO", iso2: "ls" },
  Liberia: { iso3: "LBR", iso2: "lr" },
  Libya: { iso3: "LBY", iso2: "ly" },
  Liechtenstein: { iso3: "LIE", iso2: "li" },
  Lithuania: { iso3: "LTU", iso2: "lt" },
  Luxembourg: { iso3: "LUX", iso2: "lu" },
  Macao: { iso3: "MAC", iso2: "mo" },
  Madagascar: { iso3: "MDG", iso2: "mg" },
  Malawi: { iso3: "MWI", iso2: "mw" },
  Malaysia: { iso3: "MYS", iso2: "my" },
  Maldives: { iso3: "MDV", iso2: "mv" },
  Mali: { iso3: "MLI", iso2: "ml" },
  Malta: { iso3: "MLT", iso2: "mt" },
  "Marshall Islands": { iso3: "MHL", iso2: "mh" },
  Mauritania: { iso3: "MRT", iso2: "mr" },
  Mauritius: { iso3: "MUS", iso2: "mu" },
  Mexico: { iso3: "MEX", iso2: "mx" },
  Micronesia: { iso3: "FSM", iso2: "fm" },
  Moldova: { iso3: "MDA", iso2: "md" },
  Monaco: { iso3: "MCO", iso2: "mc" },
  Mongolia: { iso3: "MNG", iso2: "mn" },
  Montenegro: { iso3: "MNE", iso2: "me" },
  Morocco: { iso3: "MAR", iso2: "ma" },
  Mozambique: { iso3: "MOZ", iso2: "mz" },
  Myanmar: { iso3: "MMR", iso2: "mm" },
  Namibia: { iso3: "NAM", iso2: "na" },
  Nauru: { iso3: "NRU", iso2: "nr" },
  Nepal: { iso3: "NPL", iso2: "np" },
  Netherlands: { iso3: "NLD", iso2: "nl" },
  "New Caledonia": { iso3: "NCL", iso2: "nc" },
  "New Zealand": { iso3: "NZL", iso2: "nz" },
  Nicaragua: { iso3: "NIC", iso2: "ni" },
  Niger: { iso3: "NER", iso2: "ne" },
  Nigeria: { iso3: "NGA", iso2: "ng" },
  "North Korea": { iso3: "PRK", iso2: "kp" },
  "North Macedonia": { iso3: "MKD", iso2: "mk" },
  Norway: { iso3: "NOR", iso2: "no" },
  Oman: { iso3: "OMN", iso2: "om" },
  Pakistan: { iso3: "PAK", iso2: "pk" },
  Palau: { iso3: "PLW", iso2: "pw" },
  Palestine: { iso3: "PSE", iso2: "ps" },
  Panama: { iso3: "PAN", iso2: "pa" },
  "Papua New Guinea": { iso3: "PNG", iso2: "pg" },
  Paraguay: { iso3: "PRY", iso2: "py" },
  Peru: { iso3: "PER", iso2: "pe" },
  Philippines: { iso3: "PHL", iso2: "ph" },
  Poland: { iso3: "POL", iso2: "pl" },
  Portugal: { iso3: "PRT", iso2: "pt" },
  "Puerto Rico": { iso3: "PRI", iso2: "pr" },
  Qatar: { iso3: "QAT", iso2: "qa" },
  Romania: { iso3: "ROU", iso2: "ro" },
  Russia: { iso3: "RUS", iso2: "ru" },
  Rwanda: { iso3: "RWA", iso2: "rw" },
  Samoa: { iso3: "WSM", iso2: "ws" },
  "San Marino": { iso3: "SMR", iso2: "sm" },
  "Sao Tome and Principe": { iso3: "STP", iso2: "st" },
  "Saudi Arabia": { iso3: "SAU", iso2: "sa" },
  Senegal: { iso3: "SEN", iso2: "sn" },
  Serbia: { iso3: "SRB", iso2: "rs" },
  Seychelles: { iso3: "SYC", iso2: "sc" },
  "Sierra Leone": { iso3: "SLE", iso2: "sl" },
  Singapore: { iso3: "SGP", iso2: "sg" },
  "Sint Maarten": { iso3: "SXM", iso2: "sx" },
  Slovakia: { iso3: "SVK", iso2: "sk" },
  Slovenia: { iso3: "SVN", iso2: "si" },
  "Solomon Islands": { iso3: "SLB", iso2: "sb" },
  Somalia: { iso3: "SOM", iso2: "so" },
  "South Africa": { iso3: "ZAF", iso2: "za" },
  "South Korea": { iso3: "KOR", iso2: "kr" },
  "South Sudan": { iso3: "SSD", iso2: "ss" },
  Spain: { iso3: "ESP", iso2: "es" },
  "Sri Lanka": { iso3: "LKA", iso2: "lk" },
  "St. Lucia": { iso3: "LCA", iso2: "lc" },
  "St. Vincent & Grenadines": { iso3: "VCT", iso2: "vc" },
  Sudan: { iso3: "SDN", iso2: "sd" },
  Suriname: { iso3: "SUR", iso2: "sr" },
  Sweden: { iso3: "SWE", iso2: "se" },
  Switzerland: { iso3: "CHE", iso2: "ch" },
  Syria: { iso3: "SYR", iso2: "sy" },
  Taiwan: { iso3: "TWN", iso2: "tw" },
  Tajikistan: { iso3: "TJK", iso2: "tj" },
  Tanzania: { iso3: "TZA", iso2: "tz" },
  Thailand: { iso3: "THA", iso2: "th" },
  "Timor-Leste": { iso3: "TLS", iso2: "tl" },
  Togo: { iso3: "TGO", iso2: "tg" },
  Tonga: { iso3: "TON", iso2: "to" },
  "Trinidad and Tobago": { iso3: "TTO", iso2: "tt" },
  Tunisia: { iso3: "TUN", iso2: "tn" },
  Turkey: { iso3: "TUR", iso2: "tr" },
  Turkmenistan: { iso3: "TKM", iso2: "tm" },
  "Turks and Caicos Islands": { iso3: "TCA", iso2: "tc" },
  Uganda: { iso3: "UGA", iso2: "ug" },
  Ukraine: { iso3: "UKR", iso2: "ua" },
  "United Arab Emirates": { iso3: "ARE", iso2: "ae" },
  "United Kingdom": { iso3: "GBR", iso2: "gb" },
  "United States": { iso3: "USA", iso2: "us" },
  "United States Minor Outlying Islands": { iso3: "PUS", iso2: "" },
  Uruguay: { iso3: "URY", iso2: "uy" },
  Uzbekistan: { iso3: "UZB", iso2: "uz" },
  Vanuatu: { iso3: "VUT", iso2: "vu" },
  Vatican: { iso3: "VAT", iso2: "va" },
  Venezuela: { iso3: "VEN", iso2: "ve" },
  Vietnam: { iso3: "VNM", iso2: "vn" },
  "Wallis and Futuna Islands": { iso3: "WLF", iso2: "wf" },
  Yemen: { iso3: "YEM", iso2: "ye" },
  Zambia: { iso3: "ZMB", iso2: "zm" },
  Zimbabwe: { iso3: "ZWE", iso2: "zw" },
};
